<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn class="mb-3" block dark color="cyan" v-on="on">대회 만들기</v-btn>
        </template>
        <v-card flat max-width="500" class="mx-auto">
            <v-card-title color="blue-grey accent-4" class="mb-3">대회 만들기</v-card-title>
            <v-card-text>
                <v-form v-model="valid" ref="form">
                    <v-text-field
                        v-model="title"
                        label="대회명"
                        :rules="titleRules"
                        hint="ex) 2019년 10월 월례대회"
                        prepend-icon="mdi-format-title"
                        required>
                    </v-text-field>
                    <v-text-field
                        v-model="time"
                        label="시간"
                        :rules="timeRules"
                        hint="ex) 2019년 10월 26일(토) 오후 4시"
                        prepend-icon="mdi-clock-outline"
                        required>
                    </v-text-field>
                    <v-text-field
                        v-model="location"
                        label="장소"
                        :rules="locationRules"
                        hint="ex) 은혜샘물교회 은혜관 6층"
                        prepend-icon="mdi-map-marker-radius"
                        required>
                    </v-text-field>
                    <v-text-field
                        v-model="fee"
                        label="회비"
                        hint="ex) 1만원"
                        prepend-icon="mdi-cash-100"
                        required>
                    </v-text-field>
                    <v-text-field
                        v-model="phone"
                        label="전화"
                        hint="ex) 010-2345-6789"
                        prepend-icon="mdi-phone"
                        required>
                    </v-text-field>
                    <v-file-input
                        v-model="file"
                        label="사진"
                        :rules="fileRules"
                        prepend-icon="mdi-camera"
                        required
                    ></v-file-input>
                    <v-textarea
                        v-model="greeting"
                        counter
                        clearable
                        clear-icon="cancel"
                        label="인사말"
                        hint="ex) 여러분 안녕하세요? ..."
                        prepend-icon="mdi-human-greeting"
                    ></v-textarea>
                    <p class="text-center caption pink--text" v-if="feedback">{{ feedback }}</p>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            :loading="loading"
                            class="mt-5 white--text"
                            color="blue-grey accent-4"
                            @click="creatingContest"
                            :disabled="!valid"
                        >보내기</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
    
</template>
<script>
import db from '@/fb'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
    props: [ 'user', 'groupId', 'group'],
    data: () => ({
        dialog: false,
        loading: false,
        valid: false,
        file: null,
        greeting: null,
        title: null,
        time: null,
        location: null,
        fee: null,
        phone: null,
        titleRules: [
            v => !!v || '대회명은 꼭 필요해요!'
        ],
        timeRules: [
            v => !!v || '시간은 꼭 필요해요!'
        ],
        locationRules: [
            v => !!v || '장소는 꼭 필요해요!'
        ],
        fileRules: [
            v => !!v || '이미지 파일은 꼭 필요해요!'
        ],
        feedback: null,
    }),
    methods: {
        creatingContest() {
            // upload the file image to the storage
            this.loading = true;

            // get file
            const file = this.file

            // get the extended file name
            const index = file.name.indexOf('.')
            const extension = file.name.slice(index).toLowerCase();

            // create a storage ref
            let storageRef = firebase.storage().ref(this.groupId + '/' + 'contests-images/' + Date.now() + extension)

            // upload file
            var metadata = {
                contentType: 'image/jpeg'
            };
            let uploadTask = storageRef.put(file, metadata)            

            // update progressive bar
            // Listen for state changes, errors, and completion of the upload.
            uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                (snapshot) => {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    // console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        // console.log('Upload is paused');
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        // console.log('Upload is running');
                        break;
                    }
                }, (error) => {

                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                        case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;

                        case 'storage/canceled':
                        // User canceled the upload
                        break;

                        case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                }
                }, () => {
                    
                    // Upload completed successfully, now we can get the download URL
                    uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                        console.log('File available at', downloadURL);

                        // push the new contest into data
                        let contest = {
                                title: this.title,
                                time: this.time,
                                location: this.location,
                                fee: this.fee,
                                phone: this.phone,
                                greeting: this.greeting,
                                image: downloadURL,
                                created: Date.now(),
                                applicants: []
                            }

                        // update the firestore
                        db.collection(this.groupId + '-contests').add(contest).then(() => {
                            this.dialog = false;
                            this.loading = false;
                        }).then(() => {
                            db.collection('contests').add({
                                ...contest,
                                groupName: this.group.name,
                                groupRegion: this.group.region,
                                groupCreator: this.group.creator,
                                groupId: this.groupId
                            })
                        })
                    })
                });
        },
    }
}
</script>

<style>

</style>